import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ALIGN, ILandingSection, ZoomPanPinchContent } from "src/modules/pe-landing-module/data/interfaces"
import ZoomPanPinchPrimitive from "../primitive/ZoomPanPinchPrimitive"
import Dummy from "./Dummy"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface ITableProps {
    section: ILandingSection
    data: ZoomPanPinchContent
}
const ZoomPanPinch = ({data, ...props}: ITableProps): JSX.Element => {
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-zoom-pan-${props.section.id}`,
            `.landing-zoom-pan-${props.section.id} {
                display: flex;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-zoom-pan-${props.section.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return !!data.incut
        ?
        <div className={`landing-content-container landing-zoom-pan-${props.section.id} ${ data.className || "" } `} style={ data.style || {} }  data-type={data.type} data-content-id={data.id}>
            <ZoomPanPinchPrimitive 
                primitive={ {
                    ...( data ), 
                } as any }
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {
                ...data, 
                className: `landing-zoom-pan-${props.section.id}`, 
            }, 
            ...props 
        }} /> 
}
export default ZoomPanPinch